import type { ReactNode } from "react";
import type { ReportSection } from "../domain";

function linkText(value:string):ReactNode[]{
  const parts=value.split(/(https?:\/\/[^\s)]+)/g);
  return parts.map((part,index)=>/^https?:\/\//.test(part)?<a key={`${part}-${index}`} href={part} target="_blank" rel="noreferrer">{part}</a>:part);
}

export function FormattedText({value}:{value:string}){
  const paragraphs=value.replace(/\r\n/g,"\n").split(/\n{2,}/).filter(Boolean);
  return <>{paragraphs.map((paragraph,index)=>{
    const lines=paragraph.split("\n").filter(Boolean),bullets=lines.length>1&&lines.every(line=>/^[-*]\s+/.test(line));
    return bullets?<ul key={index}>{lines.map((line,lineIndex)=><li key={lineIndex}>{linkText(line.replace(/^[-*]\s+/,""))}</li>)}</ul>:<p key={index}>{lines.map((line,lineIndex)=><span key={lineIndex}>{lineIndex>0&&<br/>}{linkText(line)}</span>)}</p>;
  })}</>;
}

export function SimplifiedClientBody({section,blockPrefix}:{section:ReportSection;blockPrefix:string}){
  const blocks=(section.blocks??[]).filter(block=>block.clientVisible&&block.content.trim()&&block.id.startsWith(blockPrefix));
  if(!blocks.length)return null;
  return <div className="section-six-client-body">{blocks.map(block=><section className={`report-block ${block.type.replaceAll(" ","-")}`} key={block.id}>{block.title&&<h3>{block.title}</h3>}<FormattedText value={block.content}/></section>)}</div>;
}

export function SectionSixClientBody({section}:{section:ReportSection}){
  return <SimplifiedClientBody section={section} blockPrefix="section6-client-v2-"/>;
}
